<template>
  <div class="configurador-card">

    <!-- Atalhos principais + info + colapsar numa só barra -->
    <div class="atalhos-row">
      <span class="presets-label">Visualizar por:</span>
      <div class="atalhos-grupo">
        <v-btn
            v-for="preset in presets"
            :key="preset.id"
            small depressed
            :color="presetAtivo === preset.id ? '#023449' : '#f1f5f9'"
            :style="presetAtivo === preset.id ? 'color:#ffffff!important' : 'color:#334155!important'"
            class="atalho-btn"
            @click="$emit('aplicar-preset', preset)"
        >
          <v-icon small class="mr-1" :color="presetAtivo === preset.id ? '#ffffff' : '#334155'">{{ preset.icon }}</v-icon>
          {{ preset.label }}
        </v-btn>

        <!-- Separador presets/personalizado -->
        <div class="atalhos-sep"></div>

        <!-- Personalizado -->
        <v-btn
            small depressed
            :color="presetAtivo === 'custom' ? '#023449' : '#f1f5f9'"
            :style="presetAtivo === 'custom' ? 'color:#ffffff!important' : 'color:#334155!important'"
            class="atalho-btn"
            @click="$emit('abrir-custom')"
        >
          <v-icon small class="mr-1" :color="presetAtivo === 'custom' ? '#ffffff' : '#334155'">mdi-tune-variant</v-icon>
          Personalizado
        </v-btn>
      </div>

      <!-- Espaçador -->
      <div style="flex:1"></div>

      <!-- Info de contagem -->
      <div class="barra-info">
        <v-icon small color="#94a3b8">mdi-sitemap</v-icon>
        <span v-if="modoGrupos" class="info-text">
    <strong>{{ totalGrupos }}</strong> {{ labelNivel0 }} ·
    <template v-if="totalFiltrosAtivos > 0">
      <strong class="text-filtrado">{{ totalProdutosFiltrados }}</strong> de
      <strong>{{ totalProdutos }}</strong> produtos
    </template>
    <template v-else>
      <strong>{{ totalProdutos }}</strong> produtos
    </template>
  </span>
        <span v-else class="info-text">
    <template v-if="totalFiltrosAtivos > 0">
      <strong class="text-filtrado">{{ totalProdutosFiltrados }}</strong> de
      <strong>{{ totalProdutos }}</strong> produtos
    </template>
    <template v-else>
      <strong>{{ totalProdutos }}</strong> produtos
    </template>
  </span>

        <!-- Indicador de filtros ativos -->
        <v-chip
            v-if="totalFiltrosAtivos > 0"
            x-small
            color="#7c3aed"
            text-color="white"
            class="ml-2"
        >
          <v-icon x-small left>mdi-filter</v-icon>
          {{ totalFiltrosAtivos }} {{ totalFiltrosAtivos === 1 ? 'filtro' : 'filtros' }}
        </v-chip>
      </div>

      <!-- Separador vertical -->
      <div class="barra-sep-v"></div>

      <!-- Botão limpar filtros -->
      <v-btn
          v-if="totalFiltrosAtivos > 0"
          icon small
          color="#7c3aed"
          title="Limpar todos os filtros"
          @click="$emit('limpar-filtros')"
      >
        <v-icon small>mdi-filter-off</v-icon>
      </v-btn>

      <!-- Botão colapsar -->
      <v-btn icon small color="#64748b" title="Colapsar todos" @click="$emit('colapsar-todos')">
        <v-icon small>mdi-unfold-less-horizontal</v-icon>
      </v-btn>
    </div>

    <!-- Configurador manual (só aparece no modo custom) -->
    <v-expand-transition>
      <div v-if="presetAtivo === 'custom'" class="custom-config">
        <div class="custom-label">Defina os níveis de agrupamento:</div>
        <div class="niveis-row">
          <div
              v-for="(nivelKey, idx) in niveisSelecionados"
              :key="`ns-${idx}`"
              class="nivel-slot"
          >
            <div class="nivel-numero">{{ idx + 1 }}º nível</div>
            <v-select
                :value="nivelKey"
                :items="opcoesNivel(idx)"
                item-text="label"
                item-value="key"
                dense outlined hide-details
                class="nivel-select"
                @change="val => $emit('alterar-nivel', idx, val)"
            >
              <template v-slot:item="{ item }">
                <v-list-item-icon class="mr-2 my-auto">
                  <v-icon small>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ item.label }}</v-list-item-content>
              </template>
              <template v-slot:selection="{ item }">
                <v-icon small class="mr-1" color="#023449">{{ item.icon }}</v-icon>
                <span class="nivel-selected-label">{{ item.label }}</span>
              </template>
            </v-select>
            <v-icon color="#94a3b8" size="18">mdi-chevron-right</v-icon>
          </div>

          <!-- Nível fixo: Produtos -->
          <div class="nivel-slot">
            <div class="nivel-numero">{{ niveisSelecionados.length + 1 }}º nível</div>
            <div class="nivel-fixo">
              <v-icon small color="#047857" class="mr-1">mdi-package-variant</v-icon>
              <span>Produtos</span>
              <v-chip x-small color="#d1fae5" text-color="#047857" class="ml-2">fixo</v-chip>
            </div>
          </div>

          <!-- Botões adicionar/remover nível -->
          <div class="nivel-acoes">
            <v-btn
                v-if="niveisSelecionados.length < 3"
                x-small outlined color="#023449"
                @click="$emit('adicionar-nivel')"
            >
              <v-icon x-small class="mr-1">mdi-plus</v-icon> Nível
            </v-btn>
            <v-btn
                v-if="niveisSelecionados.length > 1"
                x-small outlined color="error"
                @click="$emit('remover-nivel')"
            >
              <v-icon x-small class="mr-1">mdi-minus</v-icon> Nível
            </v-btn>
          </div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'ConfiguradorNiveis',

  props: {
    presets: {
      type: Array,
      required: true,
    },
    presetAtivo: {
      type: String,
      required: true,
    },
    niveisSelecionados: {
      type: Array,
      required: true,
    },
    dimensoes: {
      type: Object,
      required: true,
    },
    modoGrupos: {
      type: Boolean,
      default: false,
    },
    totalGrupos: {
      type: Number,
      default: 0,
    },
    totalProdutos: {
      type: Number,
      default: 0,
    },
    totalFiltrosAtivos: {
      type: Number,
      default: 0,
    },
    labelNivel0: {
      type: String,
      default: 'grupos',
    },
    totalProdutosFiltrados: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    opcoesNivel(idx) {
      const usadas = this.niveisSelecionados.filter((_, i) => i !== idx);
      return Object.values(this.dimensoes).filter(d => !usadas.includes(d.key));
    },
  },
};
</script>

<style scoped>
.text-filtrado {
  color: #7c3aed !important;
  background: linear-gradient(135deg, #f5f3ff 0%, #faf5ff 100%);
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid #e9d5ff;
}

.configurador-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 14px 20px;
  margin-top: 16px;
  box-shadow: 0 1px 3px rgba(2,52,73,.04);
}

.atalhos-row {
  display: flex; align-items: center; flex-wrap: wrap; gap: 10px;
}

.presets-label { font-size: .813rem; font-weight: 700; color: #023449; white-space: nowrap; }

.atalhos-grupo { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }

.atalho-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: .813rem !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
}

.atalhos-sep {
  width: 1px; height: 24px;
  background: #e2e8f0; margin: 0 2px;
}

.barra-info {
  display: flex; align-items: center; gap: 6px;
  white-space: nowrap;
}
.barra-sep-v {
  width: 1px; height: 20px; background: #e2e8f0; margin: 0 4px;
}

.info-text { font-size: .875rem; color: #64748b; font-weight: 500; }
.info-text strong { color: #023449; font-weight: 700; }

/* Modo custom */
.custom-config {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}

.custom-label {
  font-size: .75rem; font-weight: 700; color: #64748b;
  text-transform: uppercase; letter-spacing: .4px; margin-bottom: 12px;
}

.niveis-row {
  display: flex; align-items: center; flex-wrap: wrap; gap: 8px;
  margin-top: 6px;
}

.nivel-slot { display: flex; align-items: center; gap: 8px; position: relative; padding-top: 22px; }

.nivel-numero {
  position: absolute; top: 0; left: 0;
  font-size: .688rem; font-weight: 700; color: #94a3b8;
  text-transform: uppercase; letter-spacing: .4px; white-space: nowrap;
}

.nivel-select { width: 175px; }
.nivel-select >>> .v-input__slot { min-height: 36px !important; }

.nivel-selected-label { font-size: .813rem; font-weight: 600; color: #023449; }

.nivel-fixo {
  display: flex; align-items: center;
  padding: 6px 14px;
  background: #f0fdf4; border: 1.5px solid #bbf7d0; border-radius: 8px;
  font-size: .813rem; font-weight: 700; color: #047857;
}

.nivel-acoes { display: flex; gap: 6px; padding-top: 22px; }

.mr-1 { margin-right: 4px; }
.ml-2 { margin-left: 8px; }

@media (max-width: 768px) {
  .atalhos-row { flex-direction: column; align-items: flex-start; }
  .niveis-row { flex-direction: column; align-items: flex-start; }
}
</style>